define('SageDotCom/DataLayer/Global/youtube-video-tracker',[
    "SageDotCom/DataLayer/Events/video-interaction",
    "SageDotCom/DataLayer/Events/ga4-video-interaction",
    "youtube_api"
],
    function (VideoInteractionEvent, Ga4VideoInteractionEvent, ytApi) {

        // Possible milestones
        var milestones = [0, .1, .25, .5, .75, .9];

        function YoutubeVideoTracker() {
        }

        function trackMilestoneEvents() {
            var elapsedTime = this.getCurrentTime() / this.getDuration();
            var lastMilestone = this.tracking.milestone != undefined ? this.tracking.milestone : -1;

            // Get milestone index that matches elapsed time
            var milestone = _.findLastIndex(milestones, function (m) { return elapsedTime >= m; });

            // Raise analytics event if new milestone reached
            if (milestone > lastMilestone) {
                this.tracking.milestone = milestone;
                new VideoInteractionEvent(this, true).trigger();
            }

            // Stop tracking milestone events when video is not playing
            var state = this.getPlayerState();
            if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
                clearInterval(this.tracking.milestoneIntervalId);
            }
        }

        function trackGa4MilestoneEvents() {
            var elapsedTime = this.getCurrentTime() / this.getDuration();

            // Get milestone index that matches elapsed time
            var ga4Milestone = _.findLastIndex(milestones, function (m) { return elapsedTime >= m; });

            // Raise analytics event for the milestone >0% reached (with no duplicates)
            if (!isFlaggedGa4Milestone(this, ga4Milestone)) {
                this.tracking.ga4Milestone = ga4Milestone;
                flagGa4CurrentMilestone(this, ga4Milestone);
                if (ga4Milestone > 0) {
                    new Ga4VideoInteractionEvent(this, true, false, false).trigger();
                }
            }

            // Stop tracking milestone events when video is not playing
            var state = this.getPlayerState();
            if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
                clearInterval(this.tracking.ga4MilestoneIntervalId);
            }
        }

        function onPlayerStateChange(player) {
            // Wait until youtube player is ready
            if (!player.getPlayerState) return;

            var state = player.getPlayerState();

            // Skip execution if state has not been changed
            if (state === player.tracking.playerState) return;

            // Save current state
            player.tracking.playerState = state;

            // Track milestone events while video is playing
            if (state === YT.PlayerState.PLAYING) {
                player.tracking.milestoneIntervalId = setInterval(trackMilestoneEvents.bind(player), 500);
                //GA4 milestone events
                player.tracking.ga4MilestoneIntervalId = setInterval(trackGa4MilestoneEvents.bind(player), 500);
            }

            // Raise analytics event on several player states
            if (state === YT.PlayerState.PLAYING ||
                state === YT.PlayerState.PAUSED ||
                state === YT.PlayerState.ENDED) {
                new VideoInteractionEvent(player).trigger();
            }

            // Raise GA4 analytics event on several player states
            if (state === YT.PlayerState.PLAYING
                && !player.tracking.ga4HasBeenPlayedForTheFirstime) {
                player.tracking.ga4HasBeenPlayedForTheFirstime = true;
                //The video began playing for the first time or after 100% play completion ("video_start" event)
                new Ga4VideoInteractionEvent(player, false, false, true).trigger();
            }
            if (state === YT.PlayerState.PLAYING ||
                state === YT.PlayerState.PAUSED ||
                state === YT.PlayerState.ENDED) {
                new Ga4VideoInteractionEvent(player, false, false, false).trigger();
                if (state === YT.PlayerState.ENDED) {
                    player.tracking.ga4HasBeenPlayedForTheFirstime = false; //re-init after 100% play completion
                }
            }

            // Track GA4 SEEK events while video is playing
            player.tracking.ga4SeekCurrentTrackTime = player.getCurrentTime();
            player.tracking.ga4SeekPreviousTrackTime = player.tracking.ga4SeekCurrentTrackTime;
            player.tracking.ga4SeekSensibility = 3; //in seconds
            if (state === YT.PlayerState.PLAYING) {
                player.tracking.ga4SeekIntervalId = setInterval(
                    function () {
                        player.tracking.ga4SeekCurrentTrackTime = Math.floor(player.getCurrentTime());
                        if (player.tracking.ga4SeekCurrentTrackTime > player.tracking.ga4SeekPreviousTrackTime + player.tracking.ga4SeekSensibility) {
                            new Ga4VideoInteractionEvent(player, false, true, false).trigger();
                        }
                        player.tracking.ga4SeekPreviousTrackTime = player.tracking.ga4SeekCurrentTrackTime;
                    }, 1000, player
                );
            } else {
                clearInterval(player.tracking.ga4SeekIntervalId);
                player.tracking.ga4SeekCurrentTrackTime = player.getCurrentTime();
                player.tracking.ga4SeekPreviousTrackTime = player.tracking.ga4SeekCurrentTrackTime;
            }
        }

        function trackYoutubeVideosIn(container) {
            var iframes = container.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"]'); //+ youtube-nocookie
            var players = Array.prototype.map.call(iframes, function (i) { return YT.get(i.id); });

            // we have to poll youtube player states via setInterval 
            // since addEventListener('onStateChange', ..) is not fired for dynamically moved iframes across the DOM 
            // e.g.Modal with Button components move its content to body
            players.forEach(function (player) {
                // Attach tracking property to each youtube player to keep milestone information as well as other stuff
                if (player) {
                    player.isYoutube = true;
                    player.tracking = player.tracking || {};
                    //Special GA4 param init
                    player.tracking.ga4HasBeenPlayedForTheFirstime = false;
                    player.tracking.ga4Milestone = 0;
                    player.tracking.ga4MilestonesDecimalValues = milestones;
                    player.tracking.ga4ReachedMilestones = resetGa4ReachedMilestones();
                    //START the tracking
                    setInterval(onPlayerStateChange, 500, player);
                }
            });
        }

        function resetGa4ReachedMilestones() {
            var ga4ReachedMilestones = new Array(milestones.length).fill(false);
            return ga4ReachedMilestones;
        }

        function flagGa4CurrentMilestone(player, currentMilestone) {
            player.tracking.ga4ReachedMilestones = resetGa4ReachedMilestones();
            player.tracking.ga4ReachedMilestones[currentMilestone] = true;
        }

        function isFlaggedGa4Milestone(player, milestone) {
            return player.tracking.ga4ReachedMilestones[milestone];
        }

        YoutubeVideoTracker.prototype.start = function () {
            if (ytApi && "error_sage_fallback" in ytApi) {
                console && console.info && console.info("YoutubeVideoTracker could not load youtube api");
                return;
            }

            // Track state of all youtube players when youtube api loaded
            YT.ready(function () {
                trackYoutubeVideosIn(document.body);
            });
        }

        return YoutubeVideoTracker;
    });
